import { render } from "./ConfigSidebar.vue?vue&type=template&id=55c1fe2c&scoped=true&ts=true"
import script from "./ConfigSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigSidebar.vue?vue&type=style&index=0&id=55c1fe2c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c1fe2c"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/ConfigSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55c1fe2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55c1fe2c', __exports__)) {
    api.reload('55c1fe2c', __exports__)
  }
  
  module.hot.accept("./ConfigSidebar.vue?vue&type=template&id=55c1fe2c&scoped=true&ts=true", () => {
    api.rerender('55c1fe2c', render)
  })

}


export default __exports__